/**
 * Build-time env: define values only as numbered keys in `.env`
 * (`REACT_APP_1FACEBOOK_APP_ID`, …). Import the exports below using the
 * canonical names (no sequence digits in identifiers).
 */
const stage = process.env.REACT_APP_DEPLOY_ENV ?? 'Test'

export const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID;
export const FACEBOOK_BUSINESS_ID = process.env.REACT_APP_FACEBOOK_BUSINESS_ID;
export const ZIBUZZ_WEBSOCKET = process.env.REACT_APP_ZIBUZZ_WEBSOCKET;
export const ZIBUZZ_PUBLIC_KEY = process.env.REACT_APP_ZIBUZZ_PUBLIC_KEY;
export const ZIBUZZ_API_GATEWAY = process.env.REACT_APP_ZIBUZZ_API_GATEWAY;

export const OAUTH_REDIRECT_URI = stage === 'Prod'
  ? 'https://zibuzz.ziniz.online/metaCallback'
  : 'https://test-zibuzz.ziniz.online/metaCallback';

